import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'
import { getEmbedOptions } from '../helpers/acast'

export interface AmpACastProps {
    link: string
    theme?: 'light' | 'dark'
}

export const AmpACast: React.FC<AmpACastProps> = (props) => {
    const options = getEmbedOptions(props.link, props.theme)

    return (
        <StyledContent>
            <AmpIFrame
                width={undefined}
                height={options.height}
                src={options.src}
                frameborder={0}
                layout={'fixed-height'}
                allowSameOrigin={true}
                allowPopups={true}
                allowForms={false}
            />
        </StyledContent>
    )
}
